import { useState, useEffect, useContext  } from 'react';

import {SettingsContext} from '../components/userSettingsContext';
import { DataGridPro, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';
import {TransformDataForGrid}  from "../components/helpers";
import {Button, Chip, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip, ToggleButton, ToggleButtonGroup, IconButton} from '@mui/material';

import { ActivateSubscriptionForm } from '../Stripe/newUserWorkflow';
  
import axios from 'axios';
import { Icon as Iconify } from '@iconify/react';
import { CcActionButton, CcTitle } from "../commonComponents/styledTexts";
import { LionListbox } from '../commonComponents/inputFields';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ccColorDarkTeal } from '../components/helpersStyles';
import { CcLoader, InfoToolTip } from '../commonComponents/generalComponents';
import { lionIcons } from '../components/helpersIcons';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const stripeP = await loadStripe(process.env.REACT_APP_STRIPE_KEY);

const CardView = (props) => {

    return <div class=" rounded-xl bg-gradient-to-r from-ccColorDarkTeal to-ccColorTeal text-white shadow-2xl transition-transform sm:h-56 sm:w-96 sm:hover:scale-110">
      <div class=" m-4">
        <div class="flex justify-between">
          <div class="">
            <p class="font-light">Name</p>
            <p class="font-medium tracking-widest">{props.info.cardNameOnCard}</p>
          </div>
          <img class="h-14 w-14 object-contain" src="data:image/png;base64,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" />
        </div>
        <div class="pt-1">
          <p class="font-light">Card Number</p>
          <p class=" tracking-[0.5em] font-medium">**** **** **** {props.info.cardLast4}</p>
        </div>
        <div class="pt-4 pr-6 sm:pt-6">
          <div class="flex justify-between">
            <div class="">
              <p class="text-xs font-light">Expiry</p>
              <p class="text-base font-medium tracking-widest">{props.info.cardExpiryMonth ? props.info.cardExpiryMonth.toString().padStart(2, '0') : ''}/{props.info.cardExpiryYear}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  
}

const PlanManager = (props) => {
    const [availablePlans, setAvailablePlans] = useState([])
    const [selectedPlanId, setSelectedPlanId] = useState("");
    const [selectedPlan, setSelectedPlan] = useState("");
    const [planToggle, setPlanToggle] = useState("monthly");
    const [planSize, setPlanSize] = useState("under10M");

    const [activeStep, setActiveStep] = useState(0)
    const [errorMessage, setErrorMessage] = useState("")
    const [clientSecret, setClientSecret] = useState(undefined)
    const [showMoveToPaymentSpinner, setShowMoveToPaymentSpinner] = useState(false)

    let options = {
        // passing the SetupIntent's client secret
        //clientSecret: '{{CLIENT_SECRET}}',
        clientSecret: clientSecret,
        // Fully customizable with appearance API.
        appearance: {/*...*/},
      };

      
    useEffect(() => {
        getPlans()
    }, [])
    useEffect(() => {
        if (props.selectedPlanId) {
            setSelectedPlanId(props.selectedPlanId);
            //console.log(availablePlans.find(p => p.id === props.selectedPlanId))
            if (availablePlans.length > 0) setSelectedPlan(availablePlans.find(p => p.id === props.selectedPlanId))
        }
    }, [props.selectedPlanId])

    const getPlans = async () => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Invoices/Plans`;
            const response = await axios.get(url);
            const data = response.data;
            console.log(data)
    
            setAvailablePlans(data)
    
        } catch (error) {
            console.log(error);
        }
    }
    
    const handlePlanChange = (id) => {
        if (props.onChange) props.onChange(id)
    }
    const moveToPaymentStep = () => {
        createPaymentIntent()
    }

    const createPaymentIntent = async() => {
        try {
            setShowMoveToPaymentSpinner(true)
            const url = `${process.env.REACT_APP_LION_API_URL}/stripe/create-subscription-payment-intent/${selectedPlanId}`;
            const response = await axios.get(url);
    
            if (response.data.error) {setErrorMessage(response.data.error); return;}

            options.clientSecret = response.data.clientSecret;
            setClientSecret(response.data.clientSecret)
    
            setActiveStep(1)
                
        } catch (error) {
            //console.log(error);
            setErrorMessage("Oops something went wrong");
        }
        finally {setShowMoveToPaymentSpinner(false)}
    
    }
    
    return <div className='h-[580px] flex flex-col w-full'>
            {activeStep === 0 && <> 
                                <div className='text-ccColorDarkTeal font-poppins font-semibold'>How many emails do you send annually?</div>
                                <LionListbox items={[{id: 'under10M', name: 'Under 10 million emails annually'}, 
                                                    {id: '10-100M', name: 'Between 10 million to 100 million emails annually'},
                                                    {id: 'large', name: 'Over 100 million emails annually'}]}
                      selectedItemId={planSize}
                      onChange={(item) => setPlanSize(item.id)}
                      zIndex={1}
                      />

                            </>}

            {activeStep === 0 && planSize !== 'large' && <div className='mx-auto my-2'>                
                <ToggleButtonGroup
                    value={planToggle}
                    exclusive
                    onChange={(e, newValue) => setPlanToggle(newValue)}
                    aria-label="text alignment"
                    >
                    <ToggleButton value="annual" aria-label="left aligned">
                        <div className='flex flex-col'>
                            <div>Annual</div>
                            <div className='text-sm text-ccColorOrange'>Save 15%</div>
                        </div>
                    </ToggleButton>
                    <ToggleButton value="monthly" aria-label="centered">
                    <div>Monthly</div>
                    </ToggleButton>
                </ToggleButtonGroup>
                </div>}
            {/* Radio for Plans */}
            {/* VERSION WITH RADIO BUTTONS activeStep === 0 && <div className='flex flex-col overflow-auto'>
                    <div class=" w-fit p-1 flex flex-row gap-5 rounded-xl bg-white bg-clip-border text-gray-700 shadow-md">
                    {availablePlans.filter(p => p.metadata.type === planToggle).map(p => <div>
                            <div className='pt-1 flex flex-row gap-1 items-start cursor-pointer  hover:bg-slate-100 hover:rounded-xl' onClick={() => handlePlanChange(p.id)}>                
                    <div class="inline-flex items-center hidden">
                        <label class="relative flex items-center p-3 -mt-[6px] rounded-full cursor-pointer" htmlFor="html_version">
                        <input name="description" type="radio" value="WEB_RESOURCE"
                            checked={p.id === selectedPlanId}
                            class="before:content[''] peer relative h-5 w-5 appearance-none rounded-full border border-blue-200 text-blue-700 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-500 before:opacity-0 before:transition-opacity checked:border-blue-900 checked:before:bg-blue-700 hover:before:opacity-10"
                            id="html" />
                        <span
                            class="absolute text-blue-700 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 16 16" fill="currentColor">
                            <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                            </svg>
                        </span>
                        </label>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <Chip sx={{width:220, backgroundColor:p.metadata.textColor, color:'#fff'}} label={p.name}  />
                        <div className=' max-w-72 text-sm'>{p.description}</div>
                        <div className=' max-w-72 mt-2 mx-auto font-bold' style={{color: p.metadata.textColor}}>{p.metadata.price}</div>
                        <div className='mt-4 flex flex-col gap-y-4'>
                            {JSON.parse(p.metadata.features).map(f => <div className='flex justify-center font-medium text-ccColorDarkTeal'>
                                    {f}
                                </div>)
                                }                 
                        </div>
                    </div>

                        </div>
                        
                        </div>
                    )
                    }
                    </div>
                </div>
            */}
            {activeStep === 0 && <div className='flex flex-col overflow-auto'>
                    <div class="mx-auto p-1 flex flex-row gap-x-10">
                    {availablePlans.filter(p => p.metadata.type === planToggle && p.metadata.size === planSize).map(p => <div style={p.id === selectedPlanId ? {boxShadow: '0px 0px 8px 2px rgba(23,66,93,0.5)'} : {}} className={`border rounded-lg p-2 hover:bg-slate-100 hover:rounded-xl ${p.id === selectedPlanId ? "border-ccColorDarkTeal" : "border-gray-200"}`}>
                            <div className='pt-1 flex flex-row gap-1 items-start cursor-pointer ' onClick={() => handlePlanChange(p.id)}>                
                    <div className='flex flex-col gap-2'>
                        <Chip sx={{width:220, backgroundColor:p.metadata.textColor, color:'#fff'}} label={p.metadata.title ? p.metadata.title : p.name}  />
                        {/*<div className=' max-w-72 text-sm'>{p.description}</div>*/}
                        <div className=' max-w-72 mt-2 mx-auto font-bold' style={{color: p.metadata.textColor}}>{p.metadata.price}</div>
                        <div className='mt-4 flex flex-col gap-y-4'>
                            {JSON.parse(p.metadata.features).map(f => <div className='flex justify-center font-medium text-ccColorDarkTeal'>
                                    {f}
                                </div>)
                                }                 
                        </div>
                    </div>

                        </div>
                        
                        </div>
                    )
                    }
                    </div>
                </div>
            }
            {activeStep === 0 && planSize === 'large' && <div className='mx-auto mt-8 text-ccColorDarkTeal'>
                <div className='text-2xl font-semibold'>Looking for a bespoke Enterprise plan?</div>
                <div className='mt-2'>If your business sends over <span className='font-bold'>100 million emails a year</span>, we’d love to tailor a solution around your goals.</div>
                <div className='mt-4'><span className='font-bold'>To get started, email us at <a className='text-ccColorSecondaryPink' href='mailto:hello@codechemistry.io?subject=Enterprise%20Upgrade%20Enquiry&body='>hello@codechemistry.io</a></span> with:</div>
                <ul class="list-disc ml-4">
                    <li>Approximate email volumes</li>
                    <li>A bit about your goals, tech stack, and use cases</li>
                </ul>
                <div className='mt-2'>A member of our team will be in touch to arrange a call and create your custom annual plan.</div>
                <div className='mt-2 font-semibold'>Let’s build something powerful together.</div>
                <div className='mt-6'>Prefer to chat to our team? Schedule a call <a className='text-ccColorSecondaryPink' href='https://codechemistry.io/book-a-demo/' target='_blank' rel='noreferrer'>here</a>.</div>
                </div>}

            {activeStep === 1 && <div className='grid grid-cols-2'>
                    <div>
                        <Elements stripe={stripePromise} options={options}>
                            <ActivateSubscriptionForm returnURL={process.env.REACT_APP_STRIPE_SUBSCRIPTION_CHECKOUT_MEMBERS_RETURN_URL} />
                        </Elements>
                    </div>
                    <div className='flex flex-col items-center gap-y-2'>
                        <Chip sx={{width:180, backgroundColor:selectedPlan.metadata.textColor, color:'#fff'}} label={selectedPlan.name}  />
                        <div className=' max-w-72 text-sm'>{selectedPlan.description}</div>
                    <div className='mt-4 flex flex-col gap-y-4'>
                        {JSON.parse(selectedPlan.metadata.features).map(f => <div className='flex justify-center font-medium text-ccColorDarkTeal'>
                                {f}
                            </div>)
                            }                 
                    </div>

                    </div>
                </div>
            }
            <div className='flex grow'></div>
            {activeStep === 0 &&
                <div className='mt-4 flex flex-row justify-end gap-x-2'>
                    {/*activeStep > 0 && <CcActionButton onClick={() => setActiveStep(activeStep - 1)}>Previous</CcActionButton>*/}
                    <CcActionButton onClick={moveToPaymentStep} disabled={selectedPlanId === ""} showSpinner={showMoveToPaymentSpinner} >Next</CcActionButton>
                </div>
            }

    </div>
}

const UpdatePaymentMethodManager = (props) => {
    const [subscriptionId, setSubscriptionId] = useState("");
    const [currentPaymentMethod, setCurrentPaymentMethod] = useState(undefined);



    useEffect(() => {
        if (props.subscriptionId) {
            setSubscriptionId(props.subscriptionId);
            //getSession(props.subscriptionId)
        }
    }, [props.subscriptionId])

    useEffect(() => {
        if (props.pmId) {
            getCurrentPaymentMethod(props.pmId);
        }
    }, [props.pmId])

    const getSession = async (subId) => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Stripe/create-session/${subId}`;
            const response = await axios.get(url);
            const sessionId = response.data.sessionId;
            
            console.log(stripeP)
            stripeP.redirectToCheckout({
                // Make the id field from the Checkout Session creation API response
                // available to this file, so you can provide it as argument here
                // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                sessionId: sessionId
              })
    
        } catch (error) {
            console.log(error);
        }
    }
    const getCurrentPaymentMethod = async (pmId) => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Invoices/PaymentMethod/${pmId}`;
            const response = await axios.get(url);
            if (response.data.success) setCurrentPaymentMethod(response.data.data);
    
        } catch (error) {
            console.log(error);
        }
    }
    
    
    return <div className='h-[370px] flex flex-col gap-y-2 text-ccColorDarkTeal'>
            <div>Existing method</div>
            {currentPaymentMethod ?
                <CardView info={currentPaymentMethod} />
                :
                <div className=' mx-auto'><CcLoader /></div>
            }
            <div className='mt-2 font-bold'>You will be redirected to our partner Stripe to update your card details</div>
            <div className=' mx-auto'>
                <CcActionButton onClick={() => getSession(subscriptionId)} >Update card now</CcActionButton>
            </div>
        </div>
            
}

const SubscriptionViewer = (props) => {
    const [subscriptions, setSubscriptions] = useState([]);
    const [hasActiveSubscriptions, setHasActiveSubscriptions] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogPlanManagerOpen, setDialogPlanManagerOpen] = useState(false);
    const [dialogPaymentMethodOpen, setDialogPaymentMethodOpen] = useState(false);
    const [dialogActivateIncompleteSubscriptionOpen, setDialogActivateIncompleteSubscriptionOpen] = useState(false);
    const [selectedPlanId, setSelectedPlanId] = useState("")
    const [dialogData, setDialogData] = useState({});
    const [cancelFeedback, setCancelFeedback] = useState("");
    const [cancelComment, setCancelComment] = useState("");

    const columns = [
        { field: 'productName', headerName: 'Name', width: 200 },
        { field: 'created', headerName: 'Created', width: 140,
            valueFormatter: (params) => {
                if (params.value == null) return '';
                //return new Date(Date.parse(params.value)).toLocaleString();
                return new Date(Date.parse(params.value)).toLocaleDateString();
                }
        },
        { field: 'currentPeriodStart', headerName: 'Current Period Start', width: 140,
            valueFormatter: (params) => {
                if (params.value == null) return '';
                //return new Date(Date.parse(params.value)).toLocaleString();
                return new Date(Date.parse(params.value)).toLocaleDateString();
                }
        },
        { field: 'currentPeriodEnd', headerName: 'Current Period End', width: 140,
            valueFormatter: (params) => {
                if (params.value == null) return '';
                //return new Date(Date.parse(params.value)).toLocaleString();
                return new Date(Date.parse(params.value)).toLocaleDateString();
                }
        },
        { field: 'currency', headerName: 'Currency', width: 140 },
        { field: 'monthlyPrice', headerName: 'Monthly Price', width: 140,
            valueFormatter: (params) => {
                if (params.value == null) return '0';
                return params.value.toFixed(2);
                }
         },
        { field: 'overagesPricePerThousand', headerName: 'Overages Price', width: 140,
            valueFormatter: (params) => {
                if (params.value == null) return '';
                return `£ ${params.value} per thousand`;
                }
         },
        { field: 'status', headerName: 'Status', width: 140,
            renderCell: (params) => {
                const valueLC = params.value.toLowerCase();
                switch (valueLC)
                {
                  case 'active': 
                    return <div
                    class="relative grid select-none items-center whitespace-nowrap rounded-lg bg-green-500 py-1.5 px-3 font-sans text-xs font-bold uppercase text-white">
                    <span class="">{valueLC.toUpperCase()}</span>
                  </div>
                  default:
                    return <div
                    class="relative grid select-none items-center whitespace-nowrap rounded-lg bg-gray-900/10 py-1.5 px-3 font-sans text-xs font-bold uppercase text-gray-900">
                    <span class="">{valueLC.toUpperCase()}</span>
                    </div>
                }
            },    
         },
        {
            field: 'actions',
            type: 'actions',
            getActions: (params) =>{
                if (params.row.status === 'incomplete')
                return [
                    <InfoToolTip 
                    placement='left'
                    headLine='INCOMPLETE'
                    message={<><div>It appears you started the process to sign up for a paid plan but haven't provided your payment details yet.</div><div className='mt-2'>If you still wish to complete your purchase, please click the "View Invoice" link below.</div><div className='mt-2'> If you no longer wish to proceed, no action is required on your part, and the invoice will be automatically voided.</div></>}
                  />
                ]
                else if (params.row.status === 'active')
                return [
                    <Tooltip title='Update payment method' placement='top'><GridActionsCellItem icon={<Iconify icon='clarity:update-line' width={20} color={ccColorDarkTeal} />} onClick={() => openDialogPaymentMethod(params.row) }  /></Tooltip>,
                    <Tooltip title='Cancel subscription' placement='top'><GridActionsCellItem icon={<Iconify icon='material-symbols-light:cancel-outline' width={20} color={ccColorDarkTeal} />} onClick={() => openDialogCancelSubscription(params.row) }  /></Tooltip>,
                ]
                else
                return [
                ]
            } 
        },
        
        ];
    
    useEffect(() => {
        getSubscriptions()
    }, [])

    const getSubscriptions = async () => {
        try {  
          const url = `${process.env.REACT_APP_LION_API_URL}/Invoices/Subscriptions`;
          const response = await axios.get(url);
          const data = response.data;
          console.log(data.data)
          if (data.data.findIndex(s => s.status === "active") !== -1) setHasActiveSubscriptions(true);
          else setHasActiveSubscriptions(false)

          setSubscriptions(TransformDataForGrid(data.data, 'id'));

        } catch (error) {
          console.log(error);
        }
      }

    const cancelSubscription = async (subscriptionId, feedback, comment) => {
        try {
            const url = `${process.env.REACT_APP_LION_API_URL}/Invoices/Subscriptions/cancel`;

            const dataToPost = {subscriptionId: subscriptionId, feedback: feedback, comment: comment}
            const response = await axios.post(url, dataToPost);
            const data = response.data;
            //console.log(data.data)
            getSubscriptions() //refreshing the grid
        } catch (error) {
            console.log(error);
        }
    }

    const createSubscription = async () => {
        try {
            const url = `${process.env.REACT_APP_LION_API_URL}/Invoices/Subscriptions/create/${selectedPlanId}`;

            const response = await axios.get(url);
            const data = response.data;
            console.log(data.data)

        } catch (error) {
            console.log(error);
        }
    }

    const openDialogCancelSubscription = (dataRow) => {
        setDialogData(dataRow);
        setCancelComment("");
        setCancelFeedback("")
        setDialogOpen(true);
    }
    const openDialogPlanManager = () => {
        setDialogPlanManagerOpen(true);
    }
    const openDialogPaymentMethod = (dataRow) => {
        //console.log(dataRow)
        setDialogData(dataRow);
        setDialogPaymentMethodOpen(true);
    }
    const openDialogActivateIncompleteSubscription = (dataRow) => {
        //console.log(dataRow)
        setDialogData(dataRow);
        setDialogActivateIncompleteSubscriptionOpen(true);
    }
    const handleDialogClose = (action) => {
        if (action === 'delete') {
            cancelSubscription(dialogData.id, cancelFeedback, cancelComment);
        }
        
        setDialogData({});
        
        setDialogOpen(false);
    }
    const handleDialogPlanManagerClose = (action) => {
        if (action === 'buy') {
            createSubscription();
        }
        
        
        setDialogPlanManagerOpen(false);
    }
    const handleDialogPaymentMethodClose = (action) => {        
        
        setDialogPaymentMethodOpen(false);
    }
    const handleDialogActivateIncompleteSubscriptionClose = (action) => {        
        
        setDialogActivateIncompleteSubscriptionOpen(false);
    }
      
    return <div className='flex flex-col gap-y-2'>
            <CcTitle>Your subscriptions</CcTitle>
            <DataGridPro rows={subscriptions} columns={columns}
                        //apiRef={apiRef}
                        onRowClick={(params, e) => {if (props.onRowSelected) props.onRowSelected(params.id)}}
                        hideFooter
            />
            {!hasActiveSubscriptions &&
                        <div className='mt-2 flex flex-row gap-x-2 items-center'>
                            <div>You don't have any active subscriptions.</div>
                            <CcActionButton onClick={openDialogPlanManager} >Upgrade now</CcActionButton>
                        </div>
            }

        <Dialog onClose={() => handleDialogClose('abort')} open={dialogOpen}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description">
            <DialogTitle id="dialog-title">Cancel your subscription</DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    <div class="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
                        <svg class="flex-shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                        </svg>
                        <div>
                            <span class="font-medium">By confirming</span> this action we will cancel your subscription.
                        </div>
                    </div>

                    <div class="flex p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300" role="alert">
                        <svg class="flex-shrink-0 inline w-4 h-4 me-3 mt-0.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                        </svg>
                        <div className='flex flex-col'>
                            <span className='mb-2 font-semibold'>Important information</span>
                            <ul className='list-disc'>
                                <li>You will still be able to access your account and use images as normal until the end of the current billing period on on <span className=' font-semibold'>{new Date(Date.parse(dialogData.currentPeriodEnd)).toLocaleDateString()}</span></li>
                                <li>At the end of the billing period, images will be switched off and your account will become inactive. </li>
                                <li>We will store your data for 3 months after which time it will be permanently deleted. This cannot be undone.</li>
                                <li>If you reactivate your account within 6 months of cancelling, you will still have access to any elements you have created and images will turn back on.</li>
                            </ul>
                        </div>
                    </div>
                    <div className='mb-1'>Would you like to let us know why you are leaving?</div>
                    <LionListbox 
                        onChange={(val) => setCancelFeedback(val.id)}
                        selectedItemId={cancelFeedback}
                        items={[
                                {id: '', name: 'I prefer not to say'},
                                {id: 'customer_service', name: 'Customer service was less than expected'},
                                {id: 'low_quality', name: 'Quality was less than expected'},
                                {id: 'missing_features', name: 'Some features are missing'},
                                {id: 'other', name: 'Other reason'},
                                {id: 'switched_service', name: 'I’m switching to a different service'},
                                {id: 'too_complex', name: 'Ease of use was less than expected'},
                                {id: 'too_expensive', name: 'It’s too expensive'},
                                {id: 'unused', name: 'I don’t use the service enough'},
                            ]}
                    />
                    <div className=' mt-5'>Any additional comment:</div>
                    <div class="w-full mt-1 mb-4 p-1 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
                        <textarea id="comment" rows="5" onChange={(e) => setCancelComment(e.target.value)} class="w-full px-0 text-sm rounded-lg outline-none text-gray-900 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400" placeholder="Write a comment..." required ></textarea>
                    </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => handleDialogClose('abort')}>Cancel</Button>
                <Button onClick={() => handleDialogClose('delete')} autoFocus>
                    Confirm
                </Button>
                </DialogActions>

        </Dialog>

        <Dialog onClose={() => handleDialogPlanManagerClose('abort')} open={dialogPlanManagerOpen}
                maxWidth="lg" fullWidth >
            <DialogTitle id="dialog-title"><div className="flex flex-row items-center"><div className='text-ccColorDarkTeal'>Choose your new plan</div><div className="flex grow"></div>
                                            <IconButton variant="contained" sx={{color: ccColorDarkTeal}} onClick={() => handleDialogPlanManagerClose('abort')} >
                                                <Iconify icon="material-symbols:cancel-outline" width="32px" />
                                            </IconButton>
                                        </div></DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    <PlanManager selectedPlanId={selectedPlanId}
                            onChange={setSelectedPlanId}
                     />
                </DialogContentText>
                </DialogContent>
                {/*
                <DialogActions>
                <Button onClick={() => handleDialogPlanManagerClose('abort')}>Cancel</Button>
                <Button onClick={() => handleDialogPlanManagerClose('buy')} autoFocus disabled={selectedPlanId === ''}>
                    Confirm
                </Button>
                </DialogActions>                
                */}

        </Dialog>

        <Dialog onClose={() => handleDialogPaymentMethodClose('abort')} open={dialogPaymentMethodOpen}
                maxWidth="md" >
            <DialogTitle id="dialog-title"><div className='flex items-center flex-row text-ccColorDarkTeal'>
                    <div>Update payment method</div>
                    <div className='flex grow'></div>
                    <IconButton sx={{mr: -1, color: ccColorDarkTeal}}
                        onClick={() => handleDialogPaymentMethodClose('abort')}><Iconify icon={lionIcons.Icon_Actions_Cancel} width={34} /></IconButton>
                </div>
                </DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-description">
                    <UpdatePaymentMethodManager subscriptionId={dialogData.id} pmId={dialogData.paymentMethodId} />
                </DialogContentText>
                </DialogContent>
        </Dialog>

    </div>
}

export default function PageAdminInvoices() {
    /*
    props:

    NO props 
    */
    const {settings, setSettings} = useContext(SettingsContext);
    const apiRef = useGridApiRef();
    const [invoices, setInvoices] = useState([]);
    const [loadingInvoices, setLoadingInvoices] = useState(false);
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(undefined);

    const [showLoader, setShowLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState('');
    const [showAlreadyExistsMsg, setShowAlreadyExistsMsg] = useState(false);


    useEffect(() => {
        if (selectedSubscriptionId) getInvoices(selectedSubscriptionId)
    
    }, [selectedSubscriptionId])

    const getInvoices = async () => {
        setLoadingInvoices(true)
        try {  
          const url = `${process.env.REACT_APP_LION_API_URL}/Invoices/${selectedSubscriptionId}`;
          const response = await axios.get(url);
          const data = response.data;
          console.log(TransformDataForGrid(data.data, 'id'))
          setInvoices(TransformDataForGrid(data.data, 'id'));

        } catch (error) {
          console.log(error);
        }
        finally {setLoadingInvoices(false)}
      }
    const handleViewInvoice = (url) => {
        window.open(url, '_blank');
    }

    const columns = [
    { field: 'created', headerName: 'Created', width: 140,
        valueFormatter: (params) => {
            if (params.value == null) return '';
            //return new Date(Date.parse(params.value)).toLocaleString();
            return new Date(Date.parse(params.value)).toLocaleDateString();
            }
        },
    { field: 'currency', headerName: 'Currency', width: 100 },
    { field: 'amountDue', headerName: 'Amount Due', width: 140,
        valueFormatter: (params) => {
            if (params.value == null) return '0';
            return params.value.toFixed(2);
            }
     },
    { field: 'amountPaid', headerName: 'Amount Paid', width: 140,
        valueFormatter: (params) => {
            if (params.value == null) return '0';
            return params.value.toFixed(2);
            }
     },
    { field: 'amountRemaining', headerName: 'Amount Remaining', width: 140,
        valueFormatter: (params) => {
            if (params.value == null) return '0';
            return params.value.toFixed(2);
            }
     },
    { field: 'status', headerName: 'Status', width: 140,
        renderCell: (params) => {
            const valueLC = params.value.toLowerCase();
            switch (valueLC)
            {
              case 'paid': 
                return <div
                class="relative grid select-none items-center whitespace-nowrap rounded-lg bg-green-500 py-1.5 px-3 font-sans text-xs font-bold uppercase text-white">
                <span class="">{valueLC.toUpperCase()}</span>
              </div>
              default:
                return <div
                class="relative grid select-none items-center whitespace-nowrap rounded-lg bg-gray-900/10 py-1.5 px-3 font-sans text-xs font-bold uppercase text-gray-900">
                <span class="">{valueLC.toUpperCase()}</span>
                </div>
            }
        },    
     },
    {
        field: 'actions',
        type: 'actions',
        getActions: (params) => [
        //<GridActionsCellItem icon={<Iconify icon='carbon:view' width={20} />} onClick={() => {handleViewInvoice(params.row.hostedInvoiceURL) }} label="Edit" />,
        <div className=' text-ccColorDarkTeal cursor-pointer' onClick={() => {handleViewInvoice(params.row.hostedInvoiceURL) }} >View</div>,
        ]
    }
    
    ];
      

      
    return <div>
                <div className='flex flex-col gap-2'>
                <SubscriptionViewer onRowSelected={(id) => setSelectedSubscriptionId(id)} />
                {loadingInvoices && <div className='mt-4 flex justify-center'><CcLoader /></div>}
                {invoices.length > 0 && !loadingInvoices  && <div>
                                <CcTitle className="mt-12">Your invoices</CcTitle>
                                <DataGridPro rows={invoices} columns={columns}
                                            apiRef={apiRef}
                                            hideFooter
                                />

                                
                    </div>
    }
        </div>
      

</div>
}